import React, { useContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { Appearance, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCreatePaymentIntent } from '../../../utils/api/api';
import CheckoutForm from './CheckoutForm';
import './style.css';
import { GlobalContext } from '../../../contexts/HomeContext';
import { FormataValorNew, getStripePromise } from '../../../utils/utils';
//import { getStripePromise } from '../../../utils/utils';

//let stripePromise = getPublishableKey() !== '' ? loadStripe(getPublishableKey()) : null;

// teste
// const stripePromise = loadStripe(
//   'pk_test_51Mb8RJHox5UehZJLHWUm0YZFPtXp5cLTHoLk5zs4S73hm1wIuRV2tr93rEGnPL0rFbc2AUyxkY4uTmEC2ghBCMIx0049ZvsESn',
// );

/*
  CARTÕES TESTES

  Pagamento bem-sucedido
  4242424242424242

  Falha no pagamento
  4000000000009995

  Precisa de autenticação
  4000002500003155
*/

type Props = {
  value: number;
  obj: {
    itens: any;
    total: number;
    subtotal: number;
    taxa: number;
  };
  // eslint-disable-next-line no-unused-vars
  handleValidacao: (e?: boolean, isValidation?: boolean, paydAsAppleOrGoogle?: boolean, nsu?: string) => boolean;
  //handleValidacao: (e?: boolean, isValidation?: boolean) => boolean;
  setModalLoading: React.Dispatch<React.SetStateAction<string>>;
};

const Stripe: React.FC<Props> = ({ value, handleValidacao, setModalLoading }) => {
  const { dadosApp } = useContext(GlobalContext);
  const [clientSecret, setClientSecret] = React.useState('');
  //const VALOR = parseFloat(value.toString().replaceAll('.', '').replaceAll(',', ''));
  const VALOR = parseFloat(FormataValorNew(value.toString(), 2).replaceAll('.', '').replaceAll(',', ''));

  const appearance: Appearance = {
    theme: 'stripe',
  };

  const options: StripeElementsOptions = {
    clientSecret,
    appearance,
  };

  const handleCreatPaymentIntent = React.useCallback(async () => {
    const obj = {
      idloja: dadosApp.IdLoja,
      valor: VALOR,
      token: dadosApp.Empresa.Config.stripe_token_secreto,
    };

    const result = await StripeCreatePaymentIntent(obj);
    if (result?.data?.clientSecret) {
      setClientSecret(result.data.clientSecret);
    }
    setTimeout(() => {
      setModalLoading('none');
    }, 1000);
  }, [VALOR, setModalLoading, dadosApp]);

  React.useEffect(() => {
    if (VALOR > 0) {
      handleCreatPaymentIntent();
    }
  }, [handleCreatPaymentIntent, VALOR]);

  return (
    <div>
      {/* eslint-disable-next-line prettier/prettier */}
      {clientSecret && clientSecret !== "" && (
        <Elements stripe={getStripePromise()} options={options}>
          <CheckoutForm value={VALOR} handleValidacao={handleValidacao} clientSecret={clientSecret} />
        </Elements>
      )}
    </div>
  );
};

export default Stripe;
